import { Component, OnInit } from "@angular/core";
import {TimeManagementService} from "../../../../services/time-management-controller/time-management-controller.service";
import {WorkingTimeJsonProperties} from "../../../../models/working-time-json-properties";
import {WorkingDayProperty} from "../../../../models/working-day-property";
import {HolidayProperty} from "../../../../models/holiday-property";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {TranslatedBaseError} from "../../TranslatedBaseError";

@Component({
  selector: "time-management",
  templateUrl: "./time-management.component.html",
  styleUrls: ["./time-management.component.scss"],
  providers: [TimeManagementService],
})
export class TimeManagementComponent extends TranslatedBaseError implements OnInit {
  private workingTimeJsonProperties: WorkingTimeJsonProperties;

  public workingTimeProperties: WorkingTimeJsonProperties = new WorkingTimeJsonProperties();

  public newHoliday: HolidayProperty = new HolidayProperty();
  public isNewHolidayValid: boolean = true;

  public days: any = [
    {
      day: "Monday",
      open: false,
      am: {
        start: null,
        end: null,
      },
      pm: {
        start: null,
        end: null,
      },
    },
    {
      day: "Tuesday",
      open: false,
      am: {
        start: null,
        end: null,
      },
      pm: {
        start: null,
        end: null,
      },
    },
    {
      day: "Wednesday",
      open: false,
      am: {
        start: null,
        end: null,
      },
      pm: {
        start: null,
        end: null,
      },
    },
    {
      day: "Thursday",
      open: false,
      am: {
        start: null,
        end: null,
      },
      pm: {
        start: null,
        end: null,
      },
    },
    {
      day: "Friday",
      open: false,
      am: {
        start: null,
        end: null,
      },
      pm: {
        start: null,
        end: null,
      },
    },
    {
      day: "Saturday",
      open: false,
      am: {
        start: null,
        end: null,
      },
      pm: {
        start: null,
        end: null,
      },
    },
    {
      day: "Sunday",
      open: false,
      am: {
        start: null,
        end: null,
      },
      pm: {
        start: null,
        end: null,
      },
    },
  ];

  public today: Date = new Date();

  constructor(
    public toastr: ToastrService,
    public translateService: TranslateService,
    private timeManagementService: TimeManagementService) {
      super(toastr, translateService);
    }

  public ngOnInit(): void {
    this.timeManagementService.getWorkingTimeProperties().subscribe(
      (data) => {
        this.workingTimeProperties = data;
        this.workingTimeProperties.workingDaysInWeek = Array.from(new Set(this.workingTimeProperties.workingDaysInWeek).values()).filter((n) => n);
        this.initWorkingDays(this.workingTimeProperties.workingDays);
      },
    );
    this.newHoliday.name = null;
    this.newHoliday.fromDate = null;
    this.newHoliday.toDate = null;
  }

  public saveWorkingTimeProperties(addHoliday: boolean = false) {
    this.timeManagementService.saveWorkingTimeProperties(this.workingTimeProperties).subscribe(
      (data) => {
        this.workingTimeProperties = JSON.parse(data);
        this.initWorkingDays(this.workingTimeProperties.workingDays);
        if (addHoliday) {
          this.newHoliday.name = null;
          this.newHoliday.fromDate = null;
          this.newHoliday.toDate = null;
        }
        this.responseSuccessful("System properties updated");
      },
    );
  }

  public initWorkingDays(dayshours: any) {
    if (dayshours) {
      this.days.forEach((d, index) => {
        const isOpen = dayshours.find((h) => Number(h.weekDay) === Number(index) + 1);
        const exists = this.workingTimeProperties.workingDaysInWeek.find((w) => Number(w) === Number(index) + 1);
        if (isOpen) {
          d.open = exists ? true : false;
          d.am.start = isOpen.startAm;
          d.am.end = isOpen.endAm;
          d.pm.start = isOpen.startPm;
          d.pm.end = isOpen.endPm;
        }
      });
    }
  }

  public checkHour(firstHour, firstField, secondHour, secondField) {
    if (firstHour && firstField && secondHour && secondField) {
      const firstEl = document.getElementById(firstField);
      const secondEl = document.getElementById(secondField);
      if (firstEl && secondEl) {
        firstEl.classList.remove("is-invalid");
        secondEl.classList.remove("is-invalid");
        if ((new Date(`1/1/2000 ${firstHour}`)).getTime() >= (new Date(`1/1/2000 ${secondHour}`)).getTime()) {
          firstEl.classList.add("is-invalid");
          secondEl.classList.add("is-invalid");
          return false;
        }
        return true;
      }
      return true;
    }
    return true;
  }

  public updateWorkingDay(day: any, index: number, changeW: boolean = false) {
    if (day) {
      if (changeW) {
        day.open = !day.open;
      }
      if (day.open) {
        const isInW = this.workingTimeProperties.workingDays.find((h) => Number(h.weekDay) === Number(index) + 1);
        if (isInW) {
          isInW.startAm = day.am.start;
          isInW.endAm = day.am.end;
          isInW.startPm = day.pm.start;
          isInW.endPm = day.pm.end;
        } else {
          const newDay = new WorkingDayProperty();
          newDay.weekDay = Number(index + 1);
          newDay.startAm = day.am.start;
          newDay.endAm = day.am.end;
          newDay.startPm = day.pm.start;
          newDay.endPm = day.pm.end;
          this.workingTimeProperties.workingDays.push(newDay);
        }
        const isIwD = this.workingTimeProperties.workingDaysInWeek.find((w) => Number(w) === Number(index) + 1);
        if (isIwD === undefined || isIwD === null) {
          this.workingTimeProperties.workingDaysInWeek.push(index + 1);
        }
      } else {
        this.workingTimeProperties.workingDays.splice(this.workingTimeProperties.workingDays.findIndex((h) => Number(h.weekDay) === Number(index) + 1), 1);
        this.workingTimeProperties.workingDaysInWeek.splice(this.workingTimeProperties.workingDaysInWeek.findIndex((w) => Number(w) === Number(index) + 1), 1);
      }
    }
    if (this.checkHour(day.am.start, `dayAmStart_${index}`, day.pm.end, `dayPmEnd_${index}`)) {
      this.saveWorkingTimeProperties();
    }
  }

  public checkEndHolidayIsValid() {
    const endField = document.getElementById("holidayEnd");
    const startField = document.getElementById("holidayStart");
    const button = document.getElementById("submitHoliday");
    button.classList.remove("rumble-hover");
    endField.classList.remove("is-invalid");
    if (this.newHoliday.fromDate && this.newHoliday.toDate) {
      const from = new Date(this.newHoliday.fromDate);
      const to = new Date(this.newHoliday.toDate);
      this.checkDate(startField, from, button);
      this.checkDate(endField, to, button);
      if (new Date(this.newHoliday.fromDate).getTime() > new Date(this.newHoliday.toDate).getTime()) {
        endField.classList.add("is-invalid");
        button.classList.add("rumble-hover");
        return false;
      } else {
        return this.checkDate(startField, from, button) && this.checkDate(endField, to, button);
      }
    } else {
      return true;
    }
  }

  public checkDate(field, date, button) {
    if (isNaN(date.getTime())) {
      field.classList.add("is-invalid");
      button.classList.add("rumble-hover");
      return false;
    } else {
      field.classList.remove("is-invalid");
      button.classList.remove("rumble-hover");
      return true;
    }
  }

  public addHoliday(): void {
    if (this.newHoliday.name && this.newHoliday.fromDate && this.newHoliday.toDate && this.checkEndHolidayIsValid()) {
      this.workingTimeProperties.holidays.push(this.newHoliday);
      this.saveWorkingTimeProperties(true);
    }
  }

  public deleteHoliday(i): void {
    this.workingTimeProperties.holidays.splice(i, 1);
    this.saveWorkingTimeProperties();
  }

}
